var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JsonConvert, JsonConverter, JsonObject, JsonProperty, OperationMode, ValueCheckingMode } from "json2typescript";
import { PropertyMatchingRule } from "json2typescript/src/json2typescript/json-convert-enums";
import { Constants } from "../Constants";
import { IdConverter } from "../custom-converters/id-converter";
/**
 * @category Internal
 */
var SubListNodeConverter = /** @class */ (function () {
    function SubListNodeConverter() {
    }
    SubListNodeConverter_1 = SubListNodeConverter;
    SubListNodeConverter.prototype.serialize = function (subclasses) {
    };
    SubListNodeConverter.prototype.deserialize = function (subnodes) {
        var children;
        if (Array.isArray(subnodes)) {
            children = subnodes;
        }
        else {
            children = [subnodes];
        }
        return children
            .map(function (child) {
            return SubListNodeConverter_1.jsonConvert.deserialize(child, ListNodeV2);
        });
    };
    var SubListNodeConverter_1;
    SubListNodeConverter.jsonConvert = new JsonConvert(OperationMode.ENABLE, ValueCheckingMode.DISALLOW_NULL, false, PropertyMatchingRule.CASE_STRICT);
    SubListNodeConverter = SubListNodeConverter_1 = __decorate([
        JsonConverter
    ], SubListNodeConverter);
    return SubListNodeConverter;
}());
export { SubListNodeConverter };
/**
 * @category Model V2
 */
var ListNodeV2 = /** @class */ (function () {
    function ListNodeV2() {
        this.id = "";
        this.label = "";
        this.isRootNode = false;
        this.hasRootNode = undefined;
        this.children = [];
    }
    __decorate([
        JsonProperty("@id", String),
        __metadata("design:type", String)
    ], ListNodeV2.prototype, "id", void 0);
    __decorate([
        JsonProperty(Constants.Label, String),
        __metadata("design:type", String)
    ], ListNodeV2.prototype, "label", void 0);
    __decorate([
        JsonProperty(Constants.IsRootNode, Boolean, true),
        __metadata("design:type", Boolean)
    ], ListNodeV2.prototype, "isRootNode", void 0);
    __decorate([
        JsonProperty(Constants.HasRootNode, IdConverter, true),
        __metadata("design:type", String)
    ], ListNodeV2.prototype, "hasRootNode", void 0);
    __decorate([
        JsonProperty(Constants.HasSubListNode, SubListNodeConverter, true),
        __metadata("design:type", Array)
    ], ListNodeV2.prototype, "children", void 0);
    ListNodeV2 = __decorate([
        JsonObject("ListNode")
    ], ListNodeV2);
    return ListNodeV2;
}());
export { ListNodeV2 };
